<template>
    <div class="details_body">
        <ul class="details_tab">
            <li @click="num=0" :class="{active: num == 0}"><common-data name="appShortName_12"/>介绍 </li>
            <li @click="num=1" :class="{active: num == 1}">功能介绍</li>
            <li @click="num=2" :class="{active: num == 2}">购买须知</li>
            <!-- <li @click="num=3" :class="{active: num == 3}">服务介绍</li> -->
        </ul>
        <div class="details_gn" v-show="num == 0">
            <p class="intent">
                睿期大户室交易软件<common-data name="appShortName_12"/>，文华财经旗下的一款收费的机构交易工具软件，针对机构和专业投资者，引用产业大数据、宏观数据做价格研究，提供估值线、期现对比、扩展分析等价格研究工具；支持套利、移仓、期权组合、网格等复杂策略交易，提供算法分批下单、下单任务管理器等下单功能，可以选配多账号下单、国内五档行情数据、外盘行情数据...

            </p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 1">
            <p class="detail_title">7C机构版</p>
            <p>1.包含7E个人版功能；</p>
            <p>2.支持拆单交易、算法交易、下单任务管理器、网格交易运行池；</p>
            <p>3.提供带上下影线的价差/价比k线图、自定义套利公式、套利一键下单、内外盘套利交易、套利算法交易....</p>
            <!-- <p class="tent">* 仅限使用wh7软件登录；</p> -->
            <p class="tent">* 本服务中必须提供的数据及信息仅限用户另外付费选配的范围；服务期内我司有权对其他数据及信息进行增、减等调整</p>
            <p><a href="https://rich.wenhua.com.cn/buy.asp?pid=1" target="_blank">>>> 查看7C机构版更多功能</a></p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 2">
            <p class="tent">1.付费成功后如无功能问题或未报备使用程序化交易软件，恕不退不换。</p>
            <p class="tent">2.购买前请先下载<a href="https://rich.wenhua.com.cn/download.asp" target="_blank"><common-data name="appShortName_12"/></a>体验版了解软件基础功能。</p>
            <p class="tent">
                3.使用<common-data name="appShortName_12"/>软件的电脑配置要求：<br />
                · X86架构的4线程CPU/8G内存（RAM），或更高配置；<br />
                · 硬盘空间要求：操作系统盘与软件安装盘的剩余可用空间分别都>20G（或硬盘总容量的20%）；<br />
                · windows10、windows11等64位操作系统；
            </p>
            <p class="tent">4.推荐南方地区使用电信网络；北方地区使用联通网络，其它网络使用效果不佳。</p>
            <p class="tent">5.使用授权账号登录后可选择文华支持的任意期货公司进行交易（<a href="https://rich.wenhua.com.cn/jytd.asp?pid=1" target="_blank">查看文华支持的期货公司名单</a>），但如以后因所开户的期货公司交易通道关闭，文华不负责解决并不退还剩余费用。</p>
        
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 3">

            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                num: 2
            }
        },
        mounted () {
            
        }
    }
</script>
<style scoped>
@import url('./doc.css');
.details_gn {
    min-height: 255px;
}
</style>